module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Normal.526d6cc.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Normal.otf
// module id = oK/C
// module chunks = 1